import React, {useState, useEffect, useRef} from 'react';
import styles from './SearchInput2.module.css';
import {ReactComponent as SearchIcon} from '../../../assets/images/search.svg';
import {ReactComponent as ClearIcon} from '../../../assets/images/clear.svg';

interface SearchInput2Props {
  value?: string;
  onTyping?: (text: string) => void;
  onSearch: (text: string) => void;
  disabled?: boolean;
  className?: string;
}

const SearchInput2: React.FC<SearchInput2Props> = ({
  value = '',
  onTyping,
  onSearch,
  disabled = false,
  className = '',
}) => {
  const [inputValue, setInputValue] = useState<string>(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onTyping?.(newValue);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onSearch(inputValue);
    }
  };

  const handleSearchClick = () => {
    onSearch(inputValue);
    inputRef.current?.focus();
  };

  const handleClear = () => {
    setInputValue('');
    onTyping?.('');
    inputRef.current?.focus();
  };

  const containerClass = `${styles.container} ${className}`;

  return (
    <div className={containerClass}>
      <input
        ref={inputRef}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        className={styles.input}
        placeholder="Search"
        disabled={disabled}
      />
      {inputValue && !disabled && (
        <button
          className={styles.clearButton}
          onClick={handleClear}
          type="button"
          aria-label="Clear">
          <ClearIcon />
        </button>
      )}
      <button
        className={styles.iconButton}
        onClick={handleSearchClick}
        type="button"
        aria-label="Search"
        disabled={disabled}>
        <SearchIcon />
      </button>
    </div>
  );
};

export default SearchInput2;
